import { translations } from './translations';

export const breakdownToTKey = (
  breakdown: keyof (typeof translations)['breakdown'] | string | undefined,
): keyof typeof translations | undefined => {
  if (breakdown == 'user_satisfaction') return 'user_satisfaction';
  if (breakdown == 'frustration_reason') return 'frustration_cause';
  if (breakdown == 'action') return 'action_slug';

  return;
};
